// What /socialAuth (pages/login/googleAuthRedirect.jsx) posts to the window
// that opened a Google sign-in popup: the exam-review drawer's sign-in and
// Settings' Connect Google. Only a popup of ours that kept its opener posts,
// and only to this origin; each listener also checks the message came from
// its own popup.

// The sign-in finished: `results.accessToken` carries the token.
export const GOOGLE_POPUP_SIGNED_IN = 'Login Successful';

// Google sent the popup back without a token: the sign-in was cancelled or
// failed. The message carries nothing else, and the popup closes itself right
// after it. A listener that only accepts GOOGLE_POPUP_SIGNED_IN ignores it.
export const GOOGLE_POPUP_NOT_FINISHED = 'Login Not Finished';
